import { Box } from '@mui/material'

const Instructions = () => {
  return (
    <Box sx={{ color: '#444444', fontSize: '13px' }}>
      <p>
        Staff and contractors have been briefed on symptoms of COVID-19 and have
        been told to stay home if they aren’t feeling well. Hygiene
      </p>
      <ul>
        <li>
          Avoid contact with others (shaking hands, touching faces, hugging, and
          other intimate contact).
        </li>
        <li>Wearing of disposable nitrile gloves when required on site</li>
        <li>Avoid touching surfaces on client sites without gloves on.</li>
        <li>
          Frequently wash hands with soap and water for at least 20 seconds, or
          use an alcohol-based hand rub. Particular attention must be taken when
          using the toilet before preparing and eating food. Alcohol based hand
          sanitiser is available for all staff and contractors
        </li>
        <li>
          Wearing of face mask at all times (as required by prevailing Victorian
          Health Department regulations). Face masks are made available for all
          staff and contractors
        </li>
        <li>
          Cover your mouth when coughing and sneezing with tissue or a flexed
          elbow
        </li>
        <li> Dispose of tissues immediately</li>
        <li>
          Avoid using client staffrooms / common areas for meal breaks. Prefer
          in shaded areas outdoors if weather permits or by yourself in vehicle.
          Social Distancing
        </li>
        <li>
          Staff and contractors to work more than 1.5m away from each other,
          keeping 4sqm distance . Work in different areas on site where able.
          This includes toolbox meetings and meal breaks.
        </li>
      </ul>
    </Box>
  )
}

export default Instructions
